/**
 * @file ChangeGroup
 */

'use strict';

/**
 * @classname ChangeGroup
 * @classdesc ChangeGroup
 */
export default class ChangeGroup {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e, controller) {
		console.log(`ChangeGroup.constructor`);
		this._$e = $e;
		this._controller = controller;
		this._getAffiliations = this._$e.data('get-affiliations') || null;
		this._additionalTitle = this._$e.data('additional-title') || null;
		this._$e.on('change', () => this.onChange());
		this._controller.on('getAffiliationsComplete', () => this.onGetAffiliationsComplete());
		this._inTable = this._$e.closest('.table').hasClass('registration')? true: false;
		this._changed = false;
	}


	/**
	 * 'change' のコールバック
	 *
	 * @memberof ChangeGroup
	 * @return {undefined}
	 */
	onChange() {
		console.log(`ChangeGroup.onChange`);
		if (!this._getAffiliations) return;
		if (this._$e.val() === ''){
			console.log('group_id is empty');
			const $tr = this._$e.closest('.tr');
			if($('body').hasClass('page-revival-create')){
				console.log('page-revival-create');
				// 復活画面
				const councilId = $tr.find('.council_id').val();
				const districtId = $tr.find('.district_id').val();
				if(districtId !== '' || councilId !== ''){
					this._controller.blankGroup($tr);
				}else{
					$tr.find('.affiliation_id').html('<option value="">--</option>');
					$tr.find('.title_id').html('<option value="">--</option>');
				}
				return;
			}else{
				$tr.find('.affiliation_id').html('<option value="">--</option>');
				$tr.find('.title_id').html('<option value="">--</option>');
				return;
			}
		}
		this._additionalTitle ? this._controller.getAffiliationsAdditional(this._$e.val()) : this._controller.getAffiliations(this._$e.val())
		this._changed = true;
	}


	/**
	 * 所属リスト取得完了コールバック
	 *
	 * @memberof ChangeGroup
	 * @return {undefined}
	 */
	 onGetAffiliationsComplete() {
		if(!this._changed) return;
	 	console.log(`ChangeGroup.onGetAffiliationsComplete`);
		console.log(this._controller._affiliations);
		if(this._inTable){
			this._$e.closest('.tr').find('.affiliation_id').html(this.createOptions(this._controller._affiliations));
			this._$e.closest('.tr').find('.title_id').html('<option value="">--</option>');
		}else{
			$('.affiliation_id').html(this.createOptions(this._controller._affiliations));
			$('.title_id').html('<option value="">--</option>');
		}
		this._changed = false;
	}


	/**
	 * option生成
	 *
	 * @memberof ChangeGroup
	 * @return {undefined}
	 */
	createOptions(items) {
		console.log(`ChangeGroup.createOptions`);
		let options = '<option value="">▼選択</option>';
		items.forEach(item => options += `<option value='${item.id}'>${item.name}</option>`);
		return options
	}
}
